import { Box, Slider, Stack, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Admin.SettlementPoolBoosts;

type Props = {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
};

export const DistributionRatioSlider = ({
  value,
  onChange,
  disabled,
}: Props) => {
  const { t } = useResource();

  return (
    <Box sx={{ maxWidth: 500 }}>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {t(RESOURCES.DistributionRatio)}
      </Typography>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
      >
        <Typography variant="body2" fontWeight={600}>
          {t(RESOURCES.HunterPoolRatio)}: {value}%
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          {t(RESOURCES.ValorPoolRatio)}: {100 - value}%
        </Typography>
      </Stack>
      <Slider
        value={value}
        onChange={(_, v) => {
          if (typeof v === "number") {
            onChange(v);
          }
        }}
        min={0}
        max={100}
        step={1}
        disabled={disabled}
        valueLabelDisplay="auto"
        valueLabelFormat={(v) => `${v}% / ${100 - v}%`}
      />
    </Box>
  );
};
